import { render } from "./Header.vue?vue&type=template&id=1d8f0cce&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1d8f0cce&scoped=true&lang=css"

import exportComponent from "D:\\TeamCity\\BuildAgent2\\work\\1bfd74eb4d5fb108\\FamilyPortalApp\\familyportal-app\\src\\familyportal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8f0cce"]])

export default __exports__